import _styled from "@emotion/styled/base";
function cov_1cm6k8r7c7() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/growth/novo/inputs/Label.tsx";
  var hash = "48a277a99246ff83d10d54d41bc787ba5e85305e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/growth/novo/inputs/Label.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 50
        },
        end: {
          line: 33,
          column: 1
        }
      },
      "1": {
        start: {
          line: 35,
          column: 14
        },
        end: {
          line: 51,
          column: 1
        }
      },
      "2": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 91
        }
      },
      "3": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 50,
          column: 10
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        },
        loc: {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 43,
            column: 91
          }
        },
        line: 43
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 45,
            column: 5
          }
        },
        loc: {
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 50,
            column: 10
          }
        },
        line: 46
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 43,
            column: 54
          },
          end: {
            line: 43,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 54
          },
          end: {
            line: 43,
            column: 65
          }
        }, {
          start: {
            line: 43,
            column: 69
          },
          end: {
            line: 43,
            column: 90
          }
        }],
        line: 43
      },
      "1": {
        loc: {
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 50,
            column: 10
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        }, {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 10
          }
        }],
        line: 46
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "48a277a99246ff83d10d54d41bc787ba5e85305e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1cm6k8r7c7 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1cm6k8r7c7();
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { novo } from '@opendoor/bricks/theme';
import { buildResponsiveStyling } from "./helpers/inputSizing.mjs";
var SIZE_TO_SERIALIZED_STYLES = (cov_1cm6k8r7c7().s[0]++, {
  '200': /*#__PURE__*/css("font-size:", novo.fontSizes['16px'], ";line-height:", novo.lineHeights['130'], ";letter-spacing:-0.224px;" + (process.env.NODE_ENV === "production" ? "" : ";label:200;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
  '300': /*#__PURE__*/css("font-size:", novo.fontSizes['18px'], ";line-height:", novo.lineHeights['120'], ";letter-spacing:-0.432px;" + (process.env.NODE_ENV === "production" ? "" : ";label:300;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
  '400': /*#__PURE__*/css("font-size:", novo.fontSizes['20px'], ";line-height:", novo.lineHeights['120'], ";letter-spacing:-0.48px;" + (process.env.NODE_ENV === "production" ? "" : ";label:400;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
  '600': /*#__PURE__*/css("font-size:", novo.fontSizes['22px'], ";line-height:", novo.lineHeights['112'], ";letter-spacing:-0.528px;" + (process.env.NODE_ENV === "production" ? "" : ";label:600;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
});
var _ref = process.env.NODE_ENV === "production" ? {
  name: "cmea0f",
  styles: "color:#bd1111"
} : {
  name: "7d6wov-Label",
  styles: "color:#bd1111;label:Label;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var Label = (cov_1cm6k8r7c7().s[1]++, /*#__PURE__*/_styled("label", process.env.NODE_ENV === "production" ? {
  target: "e1orrphk0"
} : {
  target: "e1orrphk0",
  label: "Label"
})("cursor:pointer;font-family:", novo.fonts.sans, ";font-weight:", novo.fontWeights.medium, ";", function (_ref2) {
  var _ref3;
  var sizeVariant = _ref2.sizeVariant;
  cov_1cm6k8r7c7().f[0]++;
  cov_1cm6k8r7c7().s[2]++;
  return buildResponsiveStyling(SIZE_TO_SERIALIZED_STYLES, (_ref3 = (cov_1cm6k8r7c7().b[0][0]++, sizeVariant)) !== null && _ref3 !== void 0 ? _ref3 : (cov_1cm6k8r7c7().b[0][1]++, ['300', '300', '600']));
}, " ", function (props) {
  cov_1cm6k8r7c7().f[1]++;
  cov_1cm6k8r7c7().s[3]++;
  return props.error ? (cov_1cm6k8r7c7().b[1][0]++, _ref) : (cov_1cm6k8r7c7().b[1][1]++, '');
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9ncm93dGgvbm92by9pbnB1dHMvTGFiZWwudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtDc0MiLCJmaWxlIjoiLi4vLi4vLi4vLi4vc3JjL2dyb3d0aC9ub3ZvL2lucHV0cy9MYWJlbC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBub3ZvIH0gZnJvbSAnQG9wZW5kb29yL2JyaWNrcy90aGVtZSc7XG5cbmltcG9ydCB7IGJ1aWxkUmVzcG9uc2l2ZVN0eWxpbmcsIElucHV0U2l6ZVByb3AsIFNpemVUb1N0eWxlTWFwIH0gZnJvbSAnLi9oZWxwZXJzL2lucHV0U2l6aW5nJztcblxudHlwZSBMYWJlbFByb3BzID0ge1xuICBlcnJvcj86IGJvb2xlYW47XG4gIHNpemVWYXJpYW50PzogSW5wdXRTaXplUHJvcDtcbn07XG5cbmNvbnN0IFNJWkVfVE9fU0VSSUFMSVpFRF9TVFlMRVM6IFNpemVUb1N0eWxlTWFwID0ge1xuICAnMjAwJzogY3NzYFxuICAgIGZvbnQtc2l6ZTogJHtub3ZvLmZvbnRTaXplc1snMTZweCddfTtcbiAgICBsaW5lLWhlaWdodDogJHtub3ZvLmxpbmVIZWlnaHRzWycxMzAnXX07XG4gICAgbGV0dGVyLXNwYWNpbmc6IC0wLjIyNHB4O1xuICBgLFxuICAnMzAwJzogY3NzYFxuICAgIGZvbnQtc2l6ZTogJHtub3ZvLmZvbnRTaXplc1snMThweCddfTtcbiAgICBsaW5lLWhlaWdodDogJHtub3ZvLmxpbmVIZWlnaHRzWycxMjAnXX07XG4gICAgbGV0dGVyLXNwYWNpbmc6IC0wLjQzMnB4O1xuICBgLFxuICAnNDAwJzogY3NzYFxuICAgIGZvbnQtc2l6ZTogJHtub3ZvLmZvbnRTaXplc1snMjBweCddfTtcbiAgICBsaW5lLWhlaWdodDogJHtub3ZvLmxpbmVIZWlnaHRzWycxMjAnXX07XG4gICAgbGV0dGVyLXNwYWNpbmc6IC0wLjQ4cHg7XG4gIGAsXG4gICc2MDAnOiBjc3NgXG4gICAgZm9udC1zaXplOiAke25vdm8uZm9udFNpemVzWycyMnB4J119O1xuICAgIGxpbmUtaGVpZ2h0OiAke25vdm8ubGluZUhlaWdodHNbJzExMiddfTtcbiAgICBsZXR0ZXItc3BhY2luZzogLTAuNTI4cHg7XG4gIGAsXG59O1xuXG5jb25zdCBMYWJlbCA9IHN0eWxlZC5sYWJlbDxMYWJlbFByb3BzPmBcbiAgY3Vyc29yOiBwb2ludGVyO1xuXG4gIC8qIFR5cG9ncmFwaHkgKi9cbiAgZm9udC1mYW1pbHk6ICR7bm92by5mb250cy5zYW5zfTtcbiAgZm9udC13ZWlnaHQ6ICR7bm92by5mb250V2VpZ2h0cy5tZWRpdW19O1xuXG4gICR7KHsgc2l6ZVZhcmlhbnQgfSkgPT5cbiAgICBidWlsZFJlc3BvbnNpdmVTdHlsaW5nKFNJWkVfVE9fU0VSSUFMSVpFRF9TVFlMRVMsIHNpemVWYXJpYW50ID8/IFsnMzAwJywgJzMwMCcsICc2MDAnXSl9XG5cbiAgJHsocHJvcHMpID0+XG4gICAgcHJvcHMuZXJyb3JcbiAgICAgID8gY3NzYFxuICAgICAgICAgIGNvbG9yOiAjYmQxMTExO1xuICAgICAgICBgXG4gICAgICA6ICcnfVxuYDtcblxuZXhwb3J0IGRlZmF1bHQgTGFiZWw7XG4iXX0= */")));
export default Label;
//# sourceMappingURL=Label.mjs.map